var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$uiHelpers.isMobile && !_vm.$uiHelpers.isTablet
    ? _c(
        "div",
        { staticClass: "neu-cards-slider1" },
        [
          _c(
            "b-row",
            { staticClass: "section centered d-flex neu-cards-slider" },
            [
              _c(
                "div",
                { staticClass: "my-auto" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [_c("h3", [_vm._v(_vm._s(_vm.title))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row pt-5" },
                    _vm._l(_vm.cards, function(card) {
                      return _c(
                        "b-col",
                        {
                          key: _vm.cards[card],
                          class: {
                            "card-ctn": true,
                            "less-cols": _vm.getColSize < 4
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mx-auto",
                              staticStyle: { width: "inherit" }
                            },
                            [
                              _c("neu-card-general", {
                                attrs: {
                                  src: card.src,
                                  title: card.title,
                                  subtitle: card.subtitle,
                                  titleLines: card.titleLines,
                                  subtitleLines: card.subtitleLines,
                                  iconColor: _vm.iconsColor
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _c(
        "div",
        [
          _c("neu-cards-slider-2", {
            staticStyle: { display: "contents" },
            attrs: {
              cards: _vm.cards,
              title: _vm.title,
              iconsColor: _vm.iconsColor
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f518991a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f518991a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardsSlider.vue
// module id = 2565
// module chunks = 12 35 36 39 40 41 42 44 59